module.exports = __webpack_public_path__ + "static/media/vibino-feature-Add text-pic4.c042609a.png";